import axios from '@fs/zion-axios'
import { useQuery } from 'react-query'
import { useEffectiveUser } from '@fs/zion-user'

export default function useAncestralCountries() {
  const { cisId } = useEffectiveUser()

  const { data, isSuccess } = useQuery({
    queryKey: ['userSegment', { cisId }],
    queryFn: () => getUserSegment(cisId),
    enabled: !!cisId, // prevents query from running if cisId is falsy
  })

  // Only return data if it's successfully loaded
  return isSuccess ? data : undefined
}

async function getUserSegment(userCisId) {
  if (!userCisId) return undefined

  const response = await axios.get(`/service/home/pb/users/${userCisId}/segment?includeAncestorCountries=true`)
  return response.data.ancestralCountries
}
